import { useMutation } from "react-query";
import getAmtTransfer from "../services/getAmtTransfer";

function useGetAmtTransferMutation(){
    return useMutation(["get-amt-transfer"], getAmtTransfer);
}

export default useGetAmtTransferMutation;